import * as franc from 'franc-min';

// Improved Lao to Thai character mapping
const LAO_TO_THAI_MAP = {
    // Consonants
    'ກ': 'ก', 'ຂ': 'ข', 'ຄ': 'ค', 'ງ': 'ง', 'ຈ': 'จ', 
    'ສ': 'ส', 'ຊ': 'ช', 'ຍ': 'ญ', 'ດ': 'ด', 'ຕ': 'ต', 
    'ທ': 'ท', 'ນ': 'น', 'ບ': 'บ', 'ປ': 'ป', 'ຜ': 'ผ', 
    'ຟ': 'ฟ', 'ມ': 'ม', 'ຢ': 'ย', 'ລ': 'ร', 'ວ': 'ว', 
    'ຫ': 'ห', 'ອ': 'อ', 'ຮ': 'ฮ',
    
    // Vowels
    'າ': 'า', 'ິ': 'ิ', 'ີ': 'ี', 'ຶ': 'ึ', 'ື': 'ื', 
    'ັ': 'ั', 'ໍ': 'ๅ', 'ໄ': 'ไ', 'ໃ': 'ใ',
    
    // Special combinations
    'ຫມ': 'หม', 'ຫັ': 'หั', 'ຫນ': 'หน',
    
    // Numbers and other characters remain the same
    '0': '0', '1': '1', '2': '2', '3': '3', '4': '4', 
    '5': '5', '6': '6', '7': '7', '8': '8', '9': '9',
    ' ': ' ', 
};

// Function to check if text contains Lao script
const isLaoLanguage = (text) => {
    // Regex to match Lao unicode characters
    const laoScriptRegex = /[\u0E81-\u0EAE\u0EB0-\u0EBD\u0EC0-\u0ECD\u0EDC-\u0EDF]/;
    return laoScriptRegex.test(text);
};

const convertTextLaoToThai = (text) => {
    // Special handling for some character combinations first
    text = text.replace(/ຫມ/g, 'หม')
            .replace(/ຫັ/g, 'หั')
            .replace(/ຫນ/g, 'หน');

    // Then do character-by-character replacement
    return text.split('').map(char => 
    LAO_TO_THAI_MAP[char] || char
    ).join('');
};

function languageDetector() {
    const detectLanguage = (text) => {
        const detectedLang = franc.francAll(text);
        console.log(detectedLang); // This should log the language code
        return detectedLang;
    };
}

export { isLaoLanguage, convertTextLaoToThai, languageDetector };